module.exports = __webpack_public_path__ + "media/images/pic/parowki-c96e6353d46770f2fed19d96c54eb84e.webp";